import initSwiper from '../utils/swiper';

const newsletter = {
	init() {
		const selector = '.__swipe_feeds';

		if (!document.querySelector(selector)) {
			return;
		}

		initSwiper(selector, {
			loop: false,
			centeredSlides: false,
			slideToClickedSlide: false,
			spaceBetween: 24,
			navigation: true,
			navigationEls: {
				nextEl: '.__newsletter_instagram_next',
				prevEl: '.__newsletter_instagram_prev',
			},
			breakpoints: {
				0: {slidesPerView: 1.12, spaceBetween: 14},
				576: {slidesPerView: 2, spaceBetween: 18},
				992: {slidesPerView: 3, spaceBetween: 22},
				1200: {slidesPerView: 4, spaceBetween: 24},
			},
		});
	},
};

export default newsletter;
